module.exports = __webpack_public_path__ + "img/anwar_mouth.85b5f2f2.jpg";